var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDribble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4625 2.03337C9.68148 1.71084 8.84452 1.54539 7.9995 1.54649H7.99818C7.12291 1.54541 6.25662 1.72295 5.45234 2.06824C4.64805 2.41353 3.92268 2.9193 3.32061 3.55462L3.31968 3.5556C2.17869 4.75337 1.54326 6.34484 1.54551 7.99909L1.54551 7.9998C1.54551 11.564 4.43465 14.4531 7.99882 14.4531H7.9995C8.84452 14.4542 9.68148 14.2888 10.4625 13.9662C11.2436 13.6437 11.9534 13.1704 12.5515 12.5734L12.5524 12.5725C13.1554 11.9737 13.6338 11.2613 13.9598 10.4766C14.2859 9.69184 14.4532 8.85026 14.4521 8.00047L14.9754 7.9998L14.4521 7.99913C14.4532 7.14934 14.2859 6.30776 13.9598 5.52302C13.6338 4.73828 13.1554 4.02593 12.5524 3.42714L12.5515 3.42618C11.9534 2.82918 11.2436 2.35589 10.4625 2.03337ZM15.4986 7.9998C15.4998 8.98763 15.3053 9.9659 14.9262 10.8781C14.5472 11.7904 13.9911 12.6184 13.2903 13.3146C12.595 14.0085 11.7699 14.5586 10.862 14.9335C9.95381 15.3085 8.98067 15.5009 7.99815 15.4996C3.85646 15.4992 0.499235 12.1419 0.49903 8.00018C0.496493 6.07703 1.23516 4.22688 2.5615 2.83429C3.2614 2.09587 4.1046 1.50799 5.03951 1.10663C5.97442 0.705261 6.98138 0.498846 7.99881 0.500005C8.9811 0.49882 9.95401 0.691183 10.862 1.06611C11.7699 1.44103 12.595 1.99116 13.2903 2.68507C13.9912 3.38119 14.5472 4.20927 14.9262 5.12148C15.3053 6.0337 15.4998 7.01197 15.4986 7.9998Z",
    fill: "url(#paint0_linear_3128_77770)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3884 7.45484C14.6307 7.46714 14.8302 7.47726 14.9771 7.47726C15.2661 7.47726 15.5003 7.71153 15.5003 8.0005C15.5003 8.28948 15.2661 8.52375 14.9771 8.52375C14.7814 8.52375 14.5391 8.51236 14.2596 8.49923C12.9459 8.4375 10.8118 8.33723 8.84818 9.19924C6.20466 10.3601 4.29872 12.1606 3.4888 13.2479C3.31617 13.4797 2.98836 13.5276 2.75661 13.355C2.52485 13.1824 2.47692 12.8546 2.64955 12.6228C3.56283 11.3967 5.61051 9.47804 8.42748 8.24105L8.42753 8.24103C10.6506 7.26512 13.1127 7.39009 14.3884 7.45484Z",
    fill: "url(#paint1_linear_3128_77770)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9991 1.17568C5.1951 0.963329 5.52613 0.950075 5.73848 1.14607C6.84452 2.16695 9.30799 4.8052 10.2381 7.47919C10.6946 8.7914 11.0038 10.2427 11.2234 11.4646C11.3282 12.0475 11.4134 12.5828 11.4842 13.0279L11.4949 13.0946C11.5692 13.5616 11.6246 13.9035 11.6704 14.1054C11.7344 14.3872 11.5578 14.6676 11.276 14.7315C10.9942 14.7955 10.7139 14.6189 10.6499 14.3371C10.5946 14.0934 10.5331 13.7097 10.4614 13.2591L10.4511 13.1942C10.3801 12.7481 10.2964 12.222 10.1935 11.6497C9.97709 10.4461 9.67932 9.05794 9.24974 7.823C8.40785 5.40271 6.10633 2.90971 5.02871 1.91506C4.81636 1.71906 4.8031 1.38803 4.9991 1.17568Z",
    fill: "url(#paint2_linear_3128_77770)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3282 2.72377C13.5146 2.94457 13.4867 3.27469 13.266 3.46113C13.2061 3.51167 13.1343 3.57348 13.0515 3.64481C12.2525 4.33307 10.4241 5.90792 8.32145 6.80582C7.12464 7.3169 5.62521 7.54238 4.28971 7.63509C2.94478 7.72845 1.71945 7.68989 1.04545 7.64922C0.756996 7.63181 0.53727 7.38386 0.554678 7.0954C0.572086 6.80695 0.820035 6.58722 1.10849 6.60463C1.75236 6.64349 2.93027 6.68045 4.21725 6.59112C5.51366 6.50112 6.87478 6.28569 7.91047 5.84342C9.8515 5.01454 11.5558 3.54998 12.3663 2.85355C12.4512 2.78058 12.5263 2.71604 12.5908 2.66155C12.8116 2.47512 13.1417 2.50298 13.3282 2.72377ZM1.34671 10.171C1.61379 10.0607 1.91975 10.1878 2.03009 10.4548C2.5989 11.8317 3.62477 12.9705 4.93497 13.6796C5.18912 13.8171 5.28365 14.1346 5.14612 14.3888C5.00858 14.6429 4.69106 14.7375 4.43691 14.5999C2.91511 13.7764 1.72357 12.4536 1.06289 10.8544C0.952554 10.5873 1.07962 10.2814 1.34671 10.171Z",
    fill: "url(#paint3_linear_3128_77770)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03951 1.10663C5.97462 0.705174 6.98182 0.498756 7.99947 0.500006C8.28844 0.500361 8.52242 0.734911 8.52206 1.02389C8.52171 1.31287 8.28716 1.54684 7.99818 1.54649C7.12291 1.54541 6.25662 1.72295 5.45234 2.06824C4.64805 2.41353 3.92268 2.9193 3.32061 3.55461C3.3203 3.55494 3.31999 3.55527 3.31968 3.5556C2.17869 4.75337 1.54326 6.34484 1.54551 7.99908C1.54591 8.28806 1.31196 8.52264 1.02298 8.52304C0.734007 8.52343 0.499424 8.28949 0.49903 8.00051C0.496408 6.07725 1.23509 4.22696 2.5615 2.83429C3.2614 2.09587 4.1046 1.50799 5.03951 1.10663ZM10.3101 1.39396C10.4259 1.12921 10.7344 1.00849 10.9992 1.12433C11.853 1.49791 12.6299 2.02711 13.2901 2.6849C13.9911 3.38105 14.5472 4.20919 14.9262 5.12148C15.3053 6.03391 15.4999 7.01241 15.4986 8.00047C15.4985 8.92251 15.3318 9.8072 15.0259 10.6249C14.9247 10.8956 14.6232 11.0329 14.3525 10.9317C14.0819 10.8304 13.9445 10.529 14.0458 10.2583C14.3084 9.55599 14.4521 8.79514 14.4521 7.9998V7.99913C14.4532 7.14934 14.2859 6.30776 13.9598 5.52302C13.6338 4.73828 13.1554 4.02593 12.5524 3.42714L12.5518 3.42652C11.9835 2.86023 11.3147 2.40466 10.5797 2.08306C10.315 1.96723 10.1942 1.6587 10.3101 1.39396ZM13.2914 12.5741C13.4956 12.7786 13.4953 13.1099 13.2908 13.314C12.5954 14.0082 11.7701 14.5585 10.862 14.9335C9.95381 15.3085 8.98067 15.5009 7.99815 15.4996C7.70917 15.4992 7.47521 15.2647 7.47558 14.9757C7.47596 14.6867 7.71052 14.4527 7.9995 14.4531C8.84452 14.4542 9.68148 14.2888 10.4625 13.9662C11.2436 13.6437 11.9534 13.1704 12.5515 12.5734C12.756 12.3693 13.0873 12.3696 13.2914 12.5741Z",
    fill: "url(#paint4_linear_3128_77770)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3128_77770",
    x1: 7.99882,
    y1: -2.19993,
    x2: 7.99882,
    y2: 17.8995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3128_77770",
    x1: 9.02312,
    y1: 6.32316,
    x2: 9.02312,
    y2: 14.4262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3128_77770",
    x1: 8.27194,
    y1: -1.46539,
    x2: 8.27194,
    y2: 16.9426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3128_77770",
    x1: 7.00267,
    y1: 0.355585,
    x2: 7.00267,
    y2: 16.6031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3128_77770",
    x1: 7.99882,
    y1: -2.19993,
    x2: 7.99882,
    y2: 17.8995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribble);
export default __webpack_public_path__ + "static/media/dribble.cb8454474cb3d3822e905207bd30b8ce.svg";
export { ForwardRef as ReactComponent };